import { useLazyLoadQuery } from 'react-relay';
import { UNIFIED_ACCOUNT_QUERY } from '../constants';
import { UnifiedAccountQuery } from '../graphql/__generated__/UnifiedAccountQuery.graphql';

const useIsForumsModerator = (aaid: string | null | undefined): boolean => {
  if (!aaid) throw new Error('useIsForumsModerator: aaid is required');

  const account = useLazyLoadQuery<UnifiedAccountQuery>(
    UNIFIED_ACCOUNT_QUERY,
    { aaid },
    { fetchPolicy: 'store-or-network' },
  )?.unified;
  const isForumsModerator = account?.account?.isForumsModerator || false;

  return isForumsModerator;
};

export default useIsForumsModerator;
